import React from 'react';
import { FileText, PlusCircle, Trash2 } from 'react-feather';

function W2Grid({ formData, onDataChange, rowData, onAddItem, onDeleteItem, onGridEdit }) {
  return (
    <div className="form-section">
      <div className="content-box-header">
        <h2><FileText size={20} className="icon-orange" /> W-2 Income</h2>
        <div className="header-actions">
          {/* THIS BUTTON IS KEY - You must click this to see the inputs */}
          <button onClick={onAddItem} className="add-item-button">
            <PlusCircle size={16} />
            <span>Add W-2</span>
          </button>
        </div>
      </div>

      {/* --- Manual Wage Override (Optional) --- */}
      <div className="dependent-card" style={{ marginBottom: '1.5rem', border: '1px dashed #ccc' }}>
        <div className="form-group">
          <label style={{ fontWeight: 600, color: '#554633ff' }}>Manual Wage Override (Optional)</label>
          <p style={{ fontSize: '0.85rem', color: '#8b7764ff', marginBottom: '0.5rem' }}>
            Only use this if you want to override the total calculated from the W-2s below.
          </p>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="manualW2Wages" 
              value={formData?.manualW2Wages ?? ''} 
              onChange={onDataChange} 
              placeholder="Calculated Automatically" 
            />
          </div>
        </div>
      </div>

      {/* --- THE W-2 LIST --- */}
      <div className="w2-list">
        {rowData && rowData.map((row, index) => (
          <div key={row.id} className="dependent-card" style={{ marginTop: '1rem', borderLeft: '4px solid #EB8258' }}>
            <div className="dependent-card-header">
              <h4>W-2 #{index + 1}</h4>
              <button 
                onClick={() => onDeleteItem(row.id)} 
                className="delete-card-button" 
                title="Remove W-2"
                style={{ color: '#ef4444' }}
              >
                <Trash2 size={18} />
              </button>
            </div>
            
            <div className="form-row">
              <div className="form-group" style={{ flex: 2 }}>
                <label>Employer Name</label>
                <input 
                  type="text" 
                  value={row.employer || ''} 
                  onChange={(e) => onGridEdit(row.id, 'employer', e.target.value)} 
                  placeholder="Employer Name"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Wages (Box 1)</label>
                <input 
                  type="number" 
                  value={row.wages || ''} 
                  onChange={(e) => onGridEdit(row.id, 'wages', parseFloat(e.target.value) || 0)} 
                  placeholder="0.00"
                />
              </div>
              
              {/* --- THIS IS THE MISSING FIELD YOU NEED --- */}
              <div className="form-group">
                <label style={{ color: '#d97706', fontWeight: '600' }}>Federal Tax Withheld (Box 2)</label>
                <input 
                  type="number" 
                  value={row.federalTaxWithheld || ''} 
                  onChange={(e) => onGridEdit(row.id, 'federalTaxWithheld', parseFloat(e.target.value) || 0)} 
                  placeholder="0.00"
                  style={{ borderColor: '#fcd34d', backgroundColor: '#fffbeb' }}
                />
              </div>
            </div>
          </div>
        ))}
        
        {(!rowData || rowData.length === 0) && (
          <div className="empty-state-message" style={{ textAlign: 'center', padding: '2rem', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
            <p>No W-2s added yet.</p>
            <button onClick={onAddItem} className="add-item-button" style={{ margin: '10px auto' }}>
              <PlusCircle size={16} /> Add Your First W-2
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default W2Grid;